import React from 'react';
import Filters from './Filters';
import logo from '../assets/images/logo.png';

const Header = ({ cat_filters, activeCatFilter, setActiveCatFilter, filters, activeFilter, setActiveFilter, searchNote, updateSearchNotes }) => {
    return <header className="app-header">
        <div className="header-nav">
            <h1 className="app-header__title">
            <img className="app-header-logo" src={logo} alt="Logo" />
                My Notes
            </h1>
            <div className="app-header__search">
                <input type="text" className="app-header__search__input" value={searchNote}
                    onChange={(e) => updateSearchNotes(e.target.value)}
                ></input>
            </div>
        </div>

        <div className="app-header__action-bar">
            <div className="filters app-header__action-bar__status-filters">
                {
                    filters.map(
                        filter => (
                            <Filters
                                key={filter.id}
                                filter={filter}
                                activeFilter={activeFilter}
                                setActiveFilter={setActiveFilter}
                            />
                        )
                    )
                }
            </div>
            <div className="filters app-header__action-bar__category-filters">
                {
                    cat_filters.map(
                        cat_filter => (
                            <Filters
                                key={cat_filter.id}
                                filter={cat_filter}
                                activeFilter={activeCatFilter}
                                setActiveFilter={setActiveCatFilter}
                            />
                        )
                    )
                }
            </div>
        </div>
    </header>;
};

export default Header;